import { Card, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery } from '@mui/material';
import { CardBoxIncome } from './CardIncome';
import MultiValueLineChart from '../Chart/MultiValueLineChart';
import StackIncomeChart from '../Chart/StackIncomeChart';
import TwoLevelPieChart from '../Chart/TwoLevelPieChart';
import { useContext, useMemo } from 'react';
import { ProviderIncomeDashboard } from '../IncomeDashboard';
import { IResultIncomeDashboard } from '../Interface/InterfaceIncome';
import _ from "lodash";
import { numberFormatterLocale } from 'view/Backend/IncomeExpenses/Ticket/fnTickit';

const IncomeCompare = () => {

    const {
        objCompare,
        arrYear,
    } = useContext(ProviderIncomeDashboard);

    const objCompareSearch = objCompare as IResultIncomeDashboard;
    const matchesUp768 = useMediaQuery('(min-width:768px)');

    const lstCompareGraphStackLine = useMemo(() => {
        if (!objCompare) { return [] }
        let lstNew = [];
        let lstData = _.cloneDeep(objCompare.lstCompareGraphStackLine) || []
        lstData.forEach(ele => {
            let objNew = {};
            objNew["nYear"] = ele.nYear;
            objNew["nPlan"] = ele.nPlan;
            ele.lstPlanIncomeMuseum.forEach(eleSub => {
                objNew[eleSub.sField] = eleSub.sValue;
            });
            lstNew.push(objNew);
        });
        return lstNew;
    }, [objCompare])



    const lstCompareMonthPlan = useMemo(() => {
        if (!objCompare) { return [] }
        let lstNew = [];
        let lstData = _.cloneDeep(objCompare.lstCompareMonthPlan) || []
        lstData.forEach(ele => {
            let objNew = {};
            objNew["sMonth"] = ele.sMonth;
            ele.lstYearMonth.forEach(eleSub => {
                objNew[eleSub.sField] = eleSub.sValue;
            });
            lstNew.push(objNew);
        });

        return lstNew;
    }, [objCompare])

    const lstCompareMonthActual = useMemo(() => {
        if (!objCompare) { return [] }
        let lstNew = [];
        let lstData = _.cloneDeep(objCompare.lstCompareMonthActual) || []
        lstData.forEach(ele => {
            let objNew = {};
            objNew["sMonth"] = ele.sMonth;
            ele.lstYearMonth.forEach(eleSub => {
                objNew[eleSub.sField] = eleSub.sValue;
            });
            lstNew.push(objNew);
        });

        return lstNew;
    }, [objCompare])

    const arrSelectYear = useMemo(() => {
        let arrYearMap = arrYear.map(item => ({ field: "Y" + (parseInt(item) + 543), name: parseInt(item) + 543 }));
        let arrYearOrder = _.orderBy(arrYearMap, ['name'], ['asc']);

        return arrYearOrder;
    }, [arrYear])


    return (
        <Grid container spacing={2} >
            <Grid item xs={12} >
                <Grid container spacing={2}>
                    <Grid item xs={12} md={9} lg={9}>
                        <Grid container spacing={2} justifyContent={"center"}>
                            <Grid item xs={12} sm={10}>
                                <Card className='card-label-compare'>
                                    <Typography className='label-dash-head'>เปรียบเทียบข้อมูลกา​รเก็บรายได้พิพิธภัณฑ์กรมทรัพยากรธรณี</Typography>
                                </Card>
                            </Grid>
                            <Grid item xs={12} >
                                <StackIncomeChart
                                    data={lstCompareGraphStackLine}
                                    xAxis={"nYear"}
                                    lstRenderLine={objCompareSearch.lstMuseum}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={3} lg={3}>
                        <Grid container spacing={2} style={{ maxHeight: '600px', overflowY: 'auto' }}>
                            <div className="ag-format-container">
                                <div className="ag-income_box">
                                    {
                                        objCompareSearch.lstCompareCard.map(item => {
                                            return (
                                                <CardBoxIncome
                                                    key={`card_${item.sID}`}
                                                    year={item.nYear}
                                                    incomeplan={item.nIncomePlan}
                                                    incomeactual={item.nIncomeActual}
                                                />
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} >
                <Grid container spacing={2}>
                    {
                        objCompareSearch.lstCompareTwoLevel.map(item => {
                            return (
                                <Grid key={`compare_twopie_${item.nYear}`} item xs={12} md={6}>
                                    <TwoLevelPieChart
                                        year={item.nYear}
                                        dataSeries1={item.lstPieSeries1}
                                        dataSeries2={item.lstPieSeries2}
                                    />
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </Grid>
            <Grid item xs={12} >
                <MultiValueLineChart
                    keyId={"plan"}
                    title={"ข้อมูลรายได้ตามแผน"}
                    data={lstCompareMonthPlan}
                    xAxis={"sMonth"}
                    lstRenderLine={arrSelectYear}
                />
            </Grid>
            <Grid item xs={12} >
                <MultiValueLineChart
                    keyId={"actual"}
                    title={"ข้อมูลรายได้รวม"}
                    data={lstCompareMonthActual}
                    xAxis={"sMonth"}
                    lstRenderLine={arrSelectYear}
                />
            </Grid>
            <Grid item xs={12} >
                <TableContainer id='table-pinned-dashboard' component={Paper}>
                    <Table sx={{ minWidth: 1000 }} >
                        <TableHead>
                            <TableRow>
                                {matchesUp768 ? <TableCell className="sticky-cell pad-0 head-z400" padding='none' style={{ minWidth: '360px', width: '360px' }} sx={{ backgroundColor: '#a95d5e !important' }}>
                                    <TableCell className='cell-in-sticky border-l' padding='none' style={{ minWidth: '60px', width: '60px' }} sx={{ backgroundColor: '#a95d5e !important' }}></TableCell>
                                    <TableCell className='cell-in-sticky border-l' padding='none' style={{ minWidth: '300px', width: '500px' }} sx={{ backgroundColor: '#a95d5e !important' }}>รายการ</TableCell>
                                </TableCell>
                                    :
                                    <>
                                        <TableCell className='cell-in-sticky border-l' padding='none' style={{ minWidth: '60px', width: '60px' }} sx={{ backgroundColor: '#a95d5e !important' }}></TableCell>
                                        <TableCell className='cell-in-sticky border-l' padding='none' style={{ minWidth: '300px', width: '500px' }} sx={{ backgroundColor: '#a95d5e !important' }}>รายการ</TableCell>
                                    </>
                                }
                                {
                                    objCompareSearch.lstMuseumTable.length > 0 && objCompareSearch.lstMuseumTable[0].lstTableYear.map(itemYear => {
                                        return (
                                            <>
                                                <TableCell component="th" padding='none' style={{ minWidth: '150px', width: '150px' }}>รายได้ตามแผนงาน {itemYear.nYear}</TableCell>
                                                <TableCell component="th" padding='none' style={{ minWidth: '150px', width: '150px' }}>รายได้รวม {itemYear.nYear}</TableCell>
                                            </>
                                        )
                                    })
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                objCompareSearch.lstMuseumTable.map((item, index) => {
                                    return (
                                        <TableRow style={{ backgroundColor: "#f2f2f2" }}>
                                            {matchesUp768 ?
                                                <TableCell className="sticky-cell pad-0 head-z400" padding='none' style={{ minWidth: '360px', width: '360px', backgroundColor: "#f2f2f2" }}>
                                                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '60px', width: '60px' }}>{index + 1}</TableCell>
                                                    <TableCell className='cell-in-sticky border-l' padding='none' style={{ minWidth: '300px', width: '500px' }}>{item.sMuseum}</TableCell>
                                                </TableCell>
                                                :
                                                <>
                                                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '60px', width: '60px' }}>{index + 1}</TableCell>
                                                    <TableCell className='cell-in-sticky border-l' padding='none' style={{ minWidth: '300px', width: '500px' }}>{item.sMuseum}</TableCell>
                                                </>
                                            }
                                            {
                                                item.lstTableYear.map(itemYear => {
                                                    return (
                                                        <>
                                                            <TableCell padding='none' align='right'>{itemYear.nPlan === 0 ? 0 : numberFormatterLocale(itemYear.nPlan, 2)}</TableCell>
                                                            <TableCell padding='none' align='right'>{itemYear.nActual === 0 ? 0 : numberFormatterLocale(itemYear.nActual, 2)}</TableCell>
                                                        </>
                                                    )
                                                })
                                            }
                                        </TableRow>
                                    )
                                })
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    )
}

export default IncomeCompare
